// src/components/Gallery.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Gallery = ({ image, title, link = '#', state }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="lib"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ cursor: link !== '#' ? 'pointer' : 'default' }}
    >
      <Link to={link} state={state} style={{ display: 'block', position: 'relative' }}>
        {/* 1) Image */}
        <img src={image} alt={title} />

        {/* 2) Hover overlay (always in DOM) */}
        <div className="project-hover" style={{ opacity: hover ? 1 : 0 }}>
          <div className="project-hover-card">
            <h5>{title}</h5>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Gallery;
